export default {"src":"/_next/static/media/laboratory-corona.efba5b12.svg","height":317,"width":336,"blurWidth":0,"blurHeight":0};